<template>
  <ul class="contacts-list">
    <span class="contacts-list__title">Бесплатные звонки по России</span>
    <li v-for="(item, i) in data.phones" :key="i">
      <IconAndTextComponent icon="call" :value="item.title" />
    </li>
    <li>
      <IconAndTextComponent icon="location" title="Адрес" :value="data.address" />
    </li>
    <li>
      <IconAndTextComponent icon="clock" title="Режим работы" :value="data.schedule" />
    </li>
    <li>
      <IconAndTextComponent icon="sms" :value="data.email" />
    </li>
  </ul>
</template>

<script>
import IconAndTextComponent from "components/IconAndTextComponent.vue";
export default {
  name: "ShopContactsComponent",
  components: { IconAndTextComponent },
  props: {
    data: {
      type: Object,
    },
  },
};
</script>

<style lang="stylus">
.contacts-list {
  display flex
  flex-direction column
  align-items flex-start
  justify-content flex-start
  gap 10px

  &__title {
    color: var(--main-color)
    font-size: 0.625em
    line-height: 1.1
    margin-bottom -7px
    padding-left 23px
  }
}
</style>
